import React, { useState } from 'react';
import { ReactComponent as LotIcon } from 'Icons/Sidebar/Lot.svg';
import { IExperimentScreenLot } from 'business/models/Models';
import { getContainerName } from 'utils/Global';
import { ModalDetails } from 'business/models/CustomModels';
import RMModal from 'components/modal/RMModal';
import LotActions from './LotActions';
interface Props {
  lot: IExperimentScreenLot;
  setSelectedLot: (lot: IExperimentScreenLot) => void;
  deleteLot: (lot: IExperimentScreenLot) => void;
  canModify: boolean;
}
export default function Lot(props: Props) {
  const { lot, setSelectedLot, deleteLot, canModify } = props;
  const [modalDetails, setModalDetails] = useState<ModalDetails>({
    showModal: false,
    setShowModal: () => {},
    onOk: () => {},
    body: null,
    heading: '',
    isOkOnly: false,
    okButtonText: undefined,
    noButtonText: undefined,
    showButtons: true,
    dialogClassName: '',
    isCancelOnly: false,
  });

  return (
    <>
      <RMModal
        id="screenlot-lot-modal"
        showModal={modalDetails.showModal}
        setShowModal={() => setModalDetails({ ...modalDetails, showModal: false })}
        onOk={modalDetails.onOk}
        body={modalDetails.body}
        heading={modalDetails.heading}
        isOkOnly={modalDetails.isOkOnly}
        okButtonText={modalDetails.okButtonText}
        dialogClassName={modalDetails.dialogClassName}
        isCancelOnly={modalDetails.isCancelOnly}
      />
      <div id={`screenlot-lotcard-${lot.id}`} className="ingredient-card">
        <div
          id={`screenlot-lotcard-header-${lot.id}`}
          className="flex ing-icons  flex-space-between flex-y-center"
        >
          <LotIcon id={`screenlot-lotcard-icon-${lot.id}`} />
        </div>
        <div
          id={`screenlot-lotcard-content-${lot.id}`}
          className="flex flex-column ing-content"
        >
          <div id={`screenlot-lotcard-number-${lot.id}`} className="ingredient-card-text">
            {` Lot# : ${lot.lotNumber} (${getContainerName(lot.containerId)})`}
          </div>
          <div
            id={`screenlot-lotcard-comment-${lot.id}`}
            className="ingredient-card-text ing-card-light"
          >
            Comment: {lot.comment}
          </div>
          <div
            id={`screenlot-lotcard-dispensevol-${lot.id}`}
            className="ingredient-card-text ing-card-light"
          >
            Dispense Volume: {lot.dispenseVol} μL
          </div>
          <div
            id={`screenlot-lotcard-currentvol-${lot.id}`}
            className="ingredient-card-text ing-card-light"
          >
            Current Volume: {lot.currentVol} μL
          </div>
        </div>
        <LotActions
          lot={lot}
          canModify={canModify}
          onEdit={() => setSelectedLot(lot)}
          onDelete={() => deleteLot(lot)}
        />
      </div>
    </>
  );
}
